export const oosPrice = {
	emptyPrice: false,
	maxListPrice: '',
	maxOfferPrice: '',
	maxSavingPct: '',
	minListPrice: '',
	minOfferPrice: 0.00,
	minSavingPct: ''
};

